define(
  'app/setup',[
    'jquery', 'jquery.cookie', 'json2', 'i18n', 'app/lib/translations',
    'backbone', 'backbone-validation', 'app/design', 'leaflet'
  ], function(
    jquery, jq_cookie, json2, i18next, translations, Backbone,
    Validation, design, leaflet
  ) {
    var takhfifan = {};
    takhfifan.eventHub = {};
    _.extend(takhfifan.eventHub, Backbone.Events);

    takhfifan.eventHub.on('formkey', function(formKey) {
      takhfifan.formKey = formKey;
    }, this);

    i18n.init({ resStore: translations, lng: 'fa-IR' });

    var cityCookie = $.cookie('city');

    if (cityCookie != null) {
      if (!_.isNaN(cityCookie)) {
        $.removeCookie('city', {path: '/', domain: '.' + document.domain});
        $.removeCookie('city', {path: '/', domain: document.domain});
      }
    }
    // takhfifan app smart banner setup
    if(typeof $.smartbanner == 'function') {
      $.smartbanner({ daysHidden: 10, daysReminder: 10, title: 'Takhfifan', author: 'Takhfifan.com', force: null });
    }
    _.extend(Backbone.Validation.callbacks, {
      valid: function(view, attribute_value, attribute_name) {
        var $errorElement = view.$('[' + attribute_name + '="' + attribute_value + '"]');
        var $errorLabel = view.$('label[for=' + $errorElement.attr('id') + ']');
        var escapedValue = attribute_value.replace(/\[/g, '-').replace(/\]/g, '').replace(/-$/, '');
        var $parent = $errorElement.closest('.control-wrapper, .tkh-error-parent');
        var $wrapper = $errorElement.closest('.control-wrapper, .tkh-error-wrapper');
        var $errorEm = $wrapper.find('em.tkh-error');
        $wrapper.next('.tkh-wrapper-external-error').remove();
        $parent.removeClass('error');
        $wrapper.removeClass('error');
        $parent.find('.tkh-error').remove();
        $errorElement.removeClass('invalid error');
        $errorLabel.removeClass('invalid');
        view.$('.alert-error > [data-error-' + escapedValue + '=1]').remove();
        $errorEm.remove();
      },
      invalid: function(view, attribute_value, error, attribute_name) {
        var $errorElement = view.$('[' + attribute_name + '="' + attribute_value + '"]');
        var $errorLabel = view.$('label[for=' + $errorElement.attr('id') + ']');
        var $errorAlert = view.$('.alert-error');
        var escapedValue = attribute_value.replace(/\[/g, '-').replace(/\]/g, '').replace(/-$/, '');
        var formattedError = '<li data-error-' + escapedValue + '="1">' + error + '</li>';
        var $parent = $errorElement.closest('.control-wrapper, .tkh-error-parent');
        var $wrapper = $errorElement.closest('.control-wrapper, .tkh-error-wrapper');
        var $errorNotice = $('<span>' + error + '</span>');

        if ($wrapper.parents('.tkh-grand-error-container').length)
        {
          $wrapper.find('.tkh-error').remove();
          var $errorEm = $('<em class="error tkh-error"></em>');
          $errorEm.append(error);
          $wrapper.append($errorEm);
        }
        else if ($wrapper.find('.tkh-error').length) {
          $parent.find('.tkh-error')
          .empty()
          .append($errorNotice);
        } else {
          var $errorEm = $('<em class="icon-error red tkh-error"></em>');
          $errorEm.append($errorNotice);
          $wrapper.append($errorEm);
        }

        $parent.addClass('error');
        $errorElement.addClass('invalid error');
        $errorLabel.addClass('invalid');
      }
    });

    if (window.DEBUG == true) {
      window.takhfifan = takhfifan;
    }

    takhfifan.isYadisa = $('body').hasClass('yadisa-store');

    return takhfifan;
  }
);

